module.exports = __webpack_public_path__ + "img/pijl-rechts-groen.0c0a1f41f0013a87e9bc8136896606bb.svg";